// extracted by mini-css-extract-plugin
export default {"value":"DeviceListForm_value__4UR3B","tag":"DeviceListForm_tag__Azssj","deviceSelect_sty":"DeviceListForm_deviceSelect_sty__HjWk5"};